import { render, staticRenderFns } from "./ManualReadingPerWords.vue?vue&type=template&id=5aeaca7c&scoped=true"
import script from "./ManualReadingPerWords.vue?vue&type=script&lang=js"
export * from "./ManualReadingPerWords.vue?vue&type=script&lang=js"
import style0 from "./ManualReadingPerWords.vue?vue&type=style&index=0&id=5aeaca7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeaca7c",
  null
  
)

export default component.exports